import React, { useEffect } from 'react';

import classNames from 'classnames';
import { useDispatch } from 'react-redux';

import useRouterHelper from 'hooks/useRouterHelper';
import {
  setActiveChapter,
  setChapterAssignmentsLength,
  setLeafs,
} from 'redux/study/studyDetails.slice';

import NewStructureItem from '../../../Forms/NewStructureItem/NewStructureItem';
import style from '../teachingStructure.module.scss';
import useOnItemSelected from './useOnItemSelected';

interface iProps {
  title: string;
  id: string;
  lessonId: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  callback: Function;
  assignments: number;
  obj: any;
}

const TeachingStructureChapter: React.FC<iProps> = ({
  title,
  id,
  lessonId,
  callback,
  assignments,
  obj,
}) => {
  const { query } = useRouterHelper();
  const { handleOnItemSelect } = useOnItemSelected(lessonId);
  const dispatch = useDispatch();
  const rtl = obj?.rtl;
  const ltr = obj?.ltr;
  const leafs = rtl - ltr;

  const handleCheckbox = () => {
    dispatch(setChapterAssignmentsLength(assignments));
    dispatch(setActiveChapter(title));
    dispatch(setLeafs(leafs));
  };

  useEffect(() => {
    handleCheckbox();
  }, []);

  return (
    <>
      {lessonId === id && query.edit === 'true' ? (
        <NewStructureItem callback={() => callback()} value={title} />
      ) : (
        <label className={classNames('font-bold', style.select)} htmlFor={`radio_${id}`}>
          <div>{title}</div>
          <input
            id={`radio_${id}`}
            type="checkbox"
            value={id}
            checked={lessonId === id}
            onClick={handleCheckbox}
            onChange={handleOnItemSelect(id, 'structure')}
          />
          <span className={style.container} />
        </label>
      )}
    </>
  );
};

export default TeachingStructureChapter;
